// extracted by mini-css-extract-plugin
module.exports = {"input":"FieldCurrencyInput_input__SXHbA","inputSuccess":"FieldCurrencyInput_inputSuccess__3T6bL","inputError":"FieldCurrencyInput_inputError__2IXS-"};